import { FormControl, FormControlLabel, InputAdornment, LinearProgress, Paper, Radio, TextField, Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import { format, parse } from 'date-fns';
import React from 'react';
import AssistenciaOdontoService from '../../services/AssistenciaOdontoService';
import FilterBeneficiario from '../share/FilterBeneficiario';
import Utils from '../share/Utils';
import VariantSnackbar from '../share/VariantSnackbar';

const styles = theme => ({
  paper: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  },
  body: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  formControlAutoCompleteBenef: {
    marginLeft: theme.spacing.unit,
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit * 2,
    minWidth: 400,
  },
  radioCnpj: {
    marginLeft: theme.spacing.unit,
    marginBottom: theme.spacing.unit * 0.5,
  },
  radioCpf: {
    marginBottom: theme.spacing.unit * 0.5,
  },
  textFieldDtaRecibo: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
    marginLeft: theme.spacing.unit * 3,
    width: 232,
    marginRight: theme.spacing.unit,
  },
  textFieldCpfCnpj: {
    width: 180,
    margin: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  },
  textFieldObservacao: {
    margin: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 3,
    width: 640,
  },
  textFieldTxtCodigoSei: {
    width: 180,
    margin: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  textFieldNomeDentista: {
    width: 480,
    margin: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  },
  typographyTituloPaper: {
    marginLeft: theme.spacing.unit,
    marginTop: theme.spacing.unit,
    color: theme.palette.text.secondary,
    fontSize: 13
  },
  textFieldValorRecibo: {
    margin: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 3,
    width: 200,
  },
});
class FormDialogAssistenciaOdonto extends React.Component {
  utils = new Utils();
  assistenciaOdontoService = new AssistenciaOdontoService();
  constructor (props) {
    super(props);
    this.state = {
      ...this.props.reembolso,
      fetching: false,
      fetchingNomeDentista: false,
      nomesBeneficiarios: this.props.nomesBeneficiarios,
      valueRadio: 'CNPJ',
      snackOpen: false,
      snackMessage: '',
      sucesso: false,
      errorMessageData: '',
      errorMessageCpfCnpj: '',
      errorMessageNomeDentista: '',
      errorMessageValorRecibo: '',
      errorMessageValorReembolso: '',
    };
    this.state.dtaRecibo = format(parse(this.state.dtaRecibo), 'YYYY-MM-DD');
    this.state.dtaReembolso = this.state.dtaReembolso === undefined || this.state.dtaReembolso === null ? format(new Date(), 'YYYY-MM-DD') : format(parse(this.state.dtaReembolso), 'YYYY-MM-DD');    
    this.state.valRecibo = this.state.valRecibo === undefined ? '' : this.state.valRecibo;
    this.state.valReembolso = this.state.valReembolso === undefined ? '' : this.state.valReembolso;
    if (this.state.numCpfCgc !== undefined) {
      if (this.state.numCpfCgc.length === 11) {
        this.state.numCpfCgc = this.utils.formatCPFTextField(this.state.numCpfCgc, '');
        this.state.valueRadio = 'CPF';
        
      } else {
        this.state.numCpfCgc = this.utils.formatCNPJTextField(this.state.numCpfCgc, '');
        this.state.valueRadio = 'CNPJ';
      }
    }    
  }
  handleBlurCpfCnpj = async event => {
    this.setState({fetchingNomeDentista: true});
    await this.consultarNomeDentista();
    this.setState({fetchingNomeDentista: false});
  }
  consultarNomeDentista = async () => {    
    if (this.state.numCpfCgc !== undefined &&
        this.state.numCpfCgc !== '' &&
        (this.state.numCpfCgc.replace(/[^0-9]/g, '').length === 11 || this.state.numCpfCgc.replace(/[^0-9]/g, '').length === 14)) {
      let nomeDentista = '';
      nomeDentista = await this.assistenciaOdontoService.consultarNomeDentista(Number(this.state.numCpfCgc.replace(/[^0-9]/g, '')));
      if (nomeDentista === '') {
        let nomeDentistaJson = await this.assistenciaOdontoService.consultarNomeDentistaReceita(this.state.numCpfCgc.replace(/[^0-9]/g, ''));
        nomeDentista = nomeDentistaJson.nome
      }    
      this.setState({nomeDentista: nomeDentista, errorMessageNomeDentista: nomeDentista === '' ? 'O CPF/CNPJ não foi encontrado na base da Receita Federal' : ''});  
    } else {
      this.setState({nomeDentista: '', numCpfCgc: '', errorMessageNomeDentista: ''});  
    }
  }

  handleCloseSnackbar = () => {
    this.setState({ snackOpen: false });
  };

  handleClickLimpar = async () => {
    this.setState({
      numMatricula: '',
      nomeBeneficiario: ''
    });
  }

  handleSelectBeneficiario = (carteira, nome) => {
    this.setState({
      numMatricula: carteira,
      nomeBeneficiario: nome
    });
  }
  handleBlurData = event => {
    if (this.state.dtaRecibo === null ||
      this.state.dtaRecibo === undefined ||
      this.state.dtaRecibo === '') {
      this.setState({errorMessageData: 'Este campo é obrigatório'});
    } else {
      this.setState({errorMessageData: ''});
    }
  }

  handleChangeTextField = event => {
    var valorNovo = '';
    if (event.target.name === 'valRecibo') {
      valorNovo = event.target.value !== '' ? this.utils.formataValor(event.target.value, event.target.defaultValue) : '';
      this.setState({ [event.target.name]: valorNovo, errorMessageValorRecibo: '' });
    }
    if (event.target.name === 'valReembolso') {
      valorNovo = event.target.value !== '' ? this.utils.formataValor(event.target.value, event.target.defaultValue) : '';
      this.setState({ [event.target.name]: valorNovo, errorMessageValorReembolso: '' });
    }
    if (event.target.name === 'txtProcessoSei') {
      this.setState({ [event.target.name]: event.target.value.toUpperCase().substring(0, 20) });
    }
    if (event.target.name === 'txtObservacao') {
      this.setState({ [event.target.name]: event.target.value.toUpperCase().substring(0, 1000) });
    }
  };
  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }
  handleChangeObservacao = event => {
    this.setState({ [event.target.name]: event.target.value });
  };
  isSalvarDisabled = () => {
    return (this.state.nomeBeneficiario === '' ||
    this.state.nomeBeneficiario === undefined) ||

    (this.state.numCpfCgc === '' ||
    this.state.numCpfCgc === null ||
    this.state.numCpfCgc === undefined) ||

    (this.state.nomeDentista === '' ||
     this.state.nomeDentista === undefined) ||

     (this.state.errorMessageData !== '' ||
     this.state.dtaRecibo === undefined ||
     this.state.dtaRecibo === 0 ||
     this.state.dtaRecibo === '') ||

     (this.state.errorMessageValorRecibo !== '' ||
     this.state.valRecibo === undefined ||
     this.state.valRecibo === 0 ||
     this.state.valRecibo === '') ||
 
     (this.state.errorMessageValorReembolso !== '' ||
     this.state.valReembolso === undefined ||
     this.state.valReembolso === 0 ||
     this.state.valReembolso === '');
  }

  handleClickSave = async () => {
    const reembolso = {
      anoPericia: 0,
      numPericia: 0,
      codServidor: this.state.codServidor === undefined ? 0 : this.state.codServidor,
      seqDependenteRh: this.state.seqDependenteRh === undefined ? 0 : this.state.seqDependenteRh,
      numMatricula: this.state.numMatricula,
      nomeBeneficiario: '',
      dtaPericiaInicio: null,
      dtaPericiaFim: null,
      dtaReembolso: this.state.dtaReembolso,
      dtaRecibo: this.state.dtaRecibo,
      pctReembolso: 0,
      valRecibo: this.state.valRecibo.replace('.', '').replace('.', '').replace(',', '.'),
      valReembolso: this.state.valReembolso.replace('.', '').replace('.', '').replace(',', '.'),
      valPericia: 0,
      valGlosado: 0,
      valTotalOrcamento: 0,
      valEmpenhado: 0,
      codDentista: this.state.codDentista === undefined ? 0 : this.state.codDentista,
      anoRemuneracao: 0,
      mesRemuneracao: 0,
      txtObservacao: this.state.txtObservacao === undefined ? '' : this.state.txtObservacao,
      indPagoFp: 'N',
      codTipoPag: 0,
      dtaOrcamento: null,
      pctEmpenhado: 0,
      indPeriodico: 0,
      codEstado: 0,
      desEstado: '',
      nomeDentista: this.state.nomeDentista === undefined ? '' : this.state.nomeDentista,
      txtProcessoSei: this.state.txtProcessoSei === undefined || this.state.txtProcessoSei === null ? '' : this.state.txtProcessoSei,
      numCpfCgc: Number(this.state.numCpfCgc.replace('.', '').replace('.', '').replace('-', '').replace('/', '')),
      
    };
    await this.props.handleSave(reembolso);
  }
  handleChangeRadio = event => {
    this.setState({ valueRadio: event.target.value, numCpfCgc: '', nomeDentista: '', errorMessageCpfCnpj: '', errorMessageNomeDentista: '', fetchingNomeDentista: false });
  };
  handleChangeTextCpfCnpj = event => {
    var novoValor = event.target.value;
    if (this.state.valueRadio === 'CNPJ') {
      novoValor = this.utils.formatCNPJTextField(novoValor, event.target.defaultValue);
    } else {
      novoValor = this.utils.formatCPFTextField(novoValor, event.target.defaultValue);
    }
    this.setState({ [event.target.name]: novoValor });
  };
  handleBlurValorRecibo = event => {
    if (this.state.valRecibo === '' || this.state.valRecibo === null || this.state.valRecibo === undefined) {
      this.setState({errorMessageValorRecibo: 'Favor preencher o valor'});
    }
  }
  handleBlurValorReembolso = event => {
    if (this.state.valReembolso === '' || this.state.valReembolso === null || this.state.valReembolso === undefined) {
      this.setState({errorMessageValorReembolso: 'Favor preencher o valor'});
    }
  }

  render () {
    const { classes, open, handleClose, titulo } = this.props;
    return (
      <div>
        <Dialog
          disableBackdropClick
          maxWidth='md'
          fullWidth
          open={open}
          onClose={handleClose}
        >
          <DialogTitle>
            {titulo}
          </DialogTitle>
          <DialogContent>
            <Paper className={classes.body} elevation={1}>
              <Paper className={classes.body} elevation={1}>
                <Typography className={classes.typographyTituloPaper}>
                  Dados do Beneficiário
                </Typography>
                <FormControl component='filedset' className={classes.formControlAutoCompleteBenef}>
                  <FilterBeneficiario
                    beneficiarios={this.props.nomesBeneficiarios}
                    disabled={!this.props.isEditavel}
                    nomeInicial={this.state.nomeBeneficiario}
                    carteiraInicial={this.state.numMatricula}
                    handleSelectBeneficiario={this.handleSelectBeneficiario}
                    handleClickLimpar={this.handleClickLimpar} />
                </FormControl>
              </Paper>
              <Paper className={classes.body} elevation={1}>
              <Typography className={classes.typographyTituloPaper}>
                Dados do Dentista
              </Typography>
              <FormControlLabel
                  label='CNPJ'
                  disabled={!this.props.isEditavel}
                  className={classes.radioCnpj}
                  control={<Radio
                    checked={this.state.valueRadio === 'CNPJ'}
                    aria-label='CNPJ'
                    onChange={this.handleChangeRadio}
                    value='CNPJ'
                    name='radio-CNPJ' />}
                />
                <FormControlLabel
                  label='CPF'
                  disabled={!this.props.isEditavel}
                  className={classes.radioCpf}
                  control={<Radio
                    checked={this.state.valueRadio === 'CPF'}
                    aria-label='CPF'
                    onChange={this.handleChangeRadio}
                    value='CPF'
                    name='radio-CPF' />}
                />
                <FormControl>
                  <TextField
                    error={this.state.errorMessageCpfCnpj !== ''}
                    margin='dense'
                    disabled={!this.props.isEditavel}
                    className={classes.textFieldCpfCnpj}
                    name='numCpfCgc'
                    label={this.state.errorMessageCpfCnpj !== '' ? this.state.errorMessageCpfCnpj : 'CPF/CNPJ'}
                    fullWidth
                    value={this.state.numCpfCgc}
                    onChange={this.handleChangeTextCpfCnpj}
                    onBlur={this.handleBlurCpfCnpj}
                    />                
                </FormControl>
                <FormControl className={classes.textFieldNomeDentista}>
                  {this.state.fetchingNomeDentista ? <LinearProgress color='primary'/>
                  : <TextField
                    disabled
                    error={this.state.errorMessageNomeDentista !== ''}
                    margin='dense'
                    name='nomeDentista'
                    label={this.state.errorMessageNomeDentista !== '' ? this.state.errorMessageNomeDentista : 'Prestador'}
                    fullWidth
                    value={this.state.nomeDentista}/>
                }
                </FormControl>
              </Paper>
              <Paper className={classes.body} elevation={1}>
              <Typography className={classes.typographyTituloPaper}>
                Dados do Comprovante de Pagamento
              </Typography>
                <FormControl>
                  <TextField
                    id='date'
                    disabled={!this.props.isEditavel}
                    error={this.state.errorMessageData !== ''}
                    label={this.state.errorMessageData !== '' ? this.state.errorMessageData : 'Dt. Comprovante Pagto.'}
                    type='date'
                    value={this.state.dtaRecibo}
                    onChange={this.handleChange}
                    onBlur={this.handleBlurData}
                    inputProps={{
                      name: 'dtaRecibo',
                    }}
                    className={classes.textFieldDtaRecibo}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </FormControl>
                <FormControl>
                  <TextField
                    value={this.state.valRecibo === null ? '0,00' : this.utils.formataValor(this.state.valRecibo)}
                    disabled={!this.props.isEditavel}
                    margin='dense'
                    id='valRecibo'
                    name='valRecibo'
                    className={classes.textFieldValorRecibo}
                    error={this.state.errorMessageValorRecibo !== ''}
                    label={this.state.errorMessageValorRecibo !== '' ? this.state.errorMessageValorRecibo : 'Valor'}
                    fullWidth
                    onChange={this.handleChangeTextField}
                    onBlur={this.handleBlurValorRecibo}
                    InputProps={{
                      startAdornment: <InputAdornment position='start'>R$</InputAdornment>
                    }}
                  />
                </FormControl>
              </Paper>
              <Paper className={classes.body} elevation={1}>
              <Typography className={classes.typographyTituloPaper}>
                Dados do Reembolso
              </Typography>
                <FormControl>
                  <TextField
                    id='date'
                    disabled
                    label={'Data do Cadastro'}
                    type='date'
                    value={this.state.dtaReembolso}
                    inputProps={{
                      name: 'dtaReembolso',
                    }}
                    // className={classes.textFieldDtaRecibo}        
                    style={{display: 'none'}}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </FormControl>
                <FormControl>
                  <TextField
                    value={this.state.valReembolso === null ? '0,00' : this.utils.formataValor(this.state.valReembolso)}
                    disabled={!this.props.isEditavel}
                    margin='dense'
                    id='valReembolso'
                    name='valReembolso'
                    className={classes.textFieldValorRecibo}
                    error={this.state.errorMessageValorReembolso !== ''}
                    label={this.state.errorMessageValorReembolso !== '' ? this.state.errorMessageValorReembolso : 'Valor'}
                    fullWidth
                    onChange={this.handleChangeTextField}
                    onBlur={this.handleBlurValorReembolso}
                    InputProps={{
                      startAdornment: <InputAdornment position='start'>R$</InputAdornment>
                    }}
                  />
                </FormControl>
              </Paper>
              <Paper className={classes.body} elevation={1}>
                <Typography className={classes.typographyTituloPaper}>
                  Dados Gerais
                </Typography>
                <FormControl>
                  <TextField
                    id='txtProcessoSei'
                    name='txtProcessoSei'
                    value={this.state.txtProcessoSei}
                    margin='dense'
                    fullWidth
                    style={{maxlength: '40'}}
                    disabled={!this.props.isEditavel}
                    onChange={this.handleChangeTextField}
                    className={classes.textFieldTxtCodigoSei}
                    label={'Processo SEI'}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </FormControl>
                <FormControl>
                  <TextField
                    value={this.state.txtObservacao === null ? '' : this.state.txtObservacao}
                    margin='dense'
                    disabled={!this.props.isEditavel}
                    id='txtObservacao'
                    name='txtObservacao'
                    label='Observação'
                    className={classes.textFieldObservacao}
                    fullWidth
                    onChange={this.handleChangeTextField}
                    multiline
                    style={{maxlength: '1000'}}
                    rowsMax='10'
                    helperText='(max. 1.000 caracteres)'
                  />
                </FormControl>
              </Paper>
            </Paper>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color='primary' id={'fechar'}>
              Fechar
            </Button>
            <Button
              disabled={this.isSalvarDisabled() || !this.props.isEditavel}
              onClick={this.handleClickSave}
              color='primary'>
              Salvar
            </Button>
          </DialogActions>
        </Dialog>
        <VariantSnackbar
          vertical={'top'}
          horizontal={'right'}
          variant={this.state.sucesso ? 'success' : 'error'}
          message={this.state.snackMessage}
          open={this.state.snackOpen}
          handleClose={this.handleCloseSnackbar} />
      </div>
    );
  }
}
export default withStyles(styles)(FormDialogAssistenciaOdonto);
